<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>Control</a>
      </li>
    </ol>
  </div>
</div>
<div class="wrapper wrapper-content">
  <div class="row">
    <div class="col-lg-12 col-md-12 mt-2">
      <div class="card">
        <div class="card-body pb-2">
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group mb-3">
                  <label class="form-label" for="exampleFormControlInput1">Site URI</label>
                  <input [(ngModel)]="command.siteUri" type="text" class="form-control" id="siteUri" placeholder="abc-xvy" [class.is-invalid]="command.siteUri == null || command.siteUri == ''">
                </div>
                <div class="form-group mb-3">
                  <label class="form-label" for="exampleFormControlInput1">Command Action</label>
                  <input [(ngModel)]="command.action" type="text" class="form-control" id="siteUri" placeholder="do=something" [class.is-invalid]="command.action == null || command.action == ''">
                </div>
              </div>
              <div class="col-xl-6">
                <table class="table">
                  <tr>
                    <th>
                      <label>Parameter Name</label>
                    </th>
                    <th>
                      <label>Parameter Value</label>
                    </th>
                    <th><a (click)="addParameter()"><i class="fa fa-plus"></i></a></th>
                  </tr>
                  <tr *ngIf="command.parameters == null || command.parameters.length == 0">
                      <td colspan="3">No Parameters</td>
                  </tr>
                  <tr *ngFor="let parameter of command.parameters">
                    <td>
                      <input type="string" [class.is-invalid]="parameter.parameterName == null || parameter.parameterName == ''" [(ngModel)]="parameter.parameterName" class="input-group form-control"/>
                    </td>
                    <td>
                      <input type="string" [class.is-invalid]="parameter.parameterValue == null || parameter.parameterValue == ''" [(ngModel)]="parameter.parameterValue" class="input-group form-control"/>
                    </td>
                    <td>
                        <a (click)="removeParameter(parameter)"><i class="fa fa-minus"></i></a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
        </div>
        <div class="card-footer">
          <button class="btn btn-primary" (click)="runCommand()" [disabled]="!commandIsValid()">Run Command</button>
        </div>
        <div class="card-arrow">
          <div class="card-arrow-top-left"></div>
          <div class="card-arrow-top-right"></div>
          <div class="card-arrow-bottom-left"></div>
          <div class="card-arrow-bottom-right"></div>
        </div>
      </div>
    </div>  
  </div>
</div>  


  